import { Link } from "react-router-dom";

export const LogoMark = ({ className = "w-10 h-10" }) => (
  <img src="/brand/logo-96.png" srcSet="/brand/logo-96.png 1x, /brand/logo-192.png 2x" alt="" aria-hidden width={96} height={96} className={`${className} object-contain shrink-0`} />
);

export const Wordmark = ({ className = "", wide = false, height = "h-9" }) => (
  <Link to="/" data-testid="brand-wordmark" className={`inline-flex flex-col items-start leading-none ${className}`} aria-label="EditBay by Relatable Studio — home">
    {wide ? (
      <img src="/brand/logo-wide-sm.png" srcSet="/brand/logo-wide-sm.png 1x, /brand/logo-wide.png 2x" alt="EditBay by Relatable Studio" className={`${height} w-auto`} />
    ) : (
      <>
        <img src="/brand/logo-eb-1x.png" srcSet="/brand/logo-eb-1x.png 1x, /brand/logo-eb.png 2x" alt="EB" className={`${height} w-auto -ml-1`} />
        <span className="mt-0.5 text-[9px] tracking-[0.32em] text-zinc-300 font-body whitespace-nowrap" data-testid="brand-byline">by Relatable Studio</span>
      </>
    )}
  </Link>
);
